<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formDatas.spId" filterable placeholder="项目" clearable @change="partserch"
                        size="mini">
                        <el-option v-for="item in getSysCjProjectList_data || []" :label="item.spName"
                            :value="item.spId" :key="item.spId"></el-option>
                    </el-select>
                    <!-- 所属年月范围查询：month 选择器，显示 yyyy-MM，值格式 yyyyMM(如 202606)，对应后端 scptYearMonthStart / scptYearMonthEnd -->
                    <el-date-picker v-model="formDatas.scptYearMonthStart" type="month" size="mini"
                        placeholder="所属年月开始" format="yyyy-MM" value-format="yyyyMM" clearable
                        style="width: 150px;"></el-date-picker>
                    <el-date-picker v-model="formDatas.scptYearMonthEnd" type="month" size="mini"
                        placeholder="所属年月结束" format="yyyy-MM" value-format="yyyyMM" clearable
                        style="width: 150px;"></el-date-picker>
                    <el-input v-model="formDatas.scptTitle" style="width: 120px;" size="mini" placeholder="标题"
                        clearable></el-input>
                    <el-input v-model="formDatas.scptContent" style="width: 120px;" size="mini" placeholder="内容"
                        clearable></el-input>
                    <el-input v-model="formDatas.scptHandlerUser" style="width: 120px;" size="mini" placeholder="参与人"
                        clearable></el-input>
                    <el-input v-model="formDatas.createusername" style="width: 120px;" size="mini" placeholder="创建人"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.scptType" clearable @change="partserch" placeholder="类型"
                        style="width: 130px">
                        <el-option label="任务" :value="1" key="1"></el-option>
                        <el-option label="需求更改" :value="2" key="2"></el-option>
                        <el-option label="配置" :value="3" key="3"></el-option>
                        <el-option label="bug" :value="4" key="4"></el-option>
                        <el-option label="其他" :value="5" key="5"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.scptStatus" clearable @change="partserch"
                        placeholder="状态" style="width: 130px">
                        <el-option label="开启" :value="1" key="1"></el-option>
                        <el-option label="关闭" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.scptStatusBack" clearable @change="partserch"
                        placeholder="后端状态" style="width: 130px">
                        <el-option label="不需要" :value="1" key="1"></el-option>
                        <el-option label="待处理" :value="2" key="2"></el-option>
                        <el-option label="处理中" :value="3" key="3"></el-option>
                        <el-option label="已完成" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.scptStatusWeb" clearable @change="partserch"
                        placeholder="前端状态" style="width: 130px">
                        <el-option label="不需要" :value="1" key="1"></el-option>
                        <el-option label="待处理" :value="2" key="2"></el-option>
                        <el-option label="处理中" :value="3" key="3"></el-option>
                        <el-option label="已完成" :value="4" key="4"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="scptId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑项目任务' : '新增项目任务'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="项目" prop="spId">
                                <el-select v-model="form.spId" filterable placeholder="请选择">
                                    <el-option v-for="item in getSysCjProjectList_data || []" :label="item.spName"
                                        :value="item.spId" :key="item.spId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="项目任务类型" prop="scptType">
                                <el-select size="mini" v-model="form.scptType" clearable placeholder="请选择"
                                    style="width: 130px">
                                    <el-option label="任务" :value="1" key="1"></el-option>
                                    <el-option label="需求更改" :value="2" key="2"></el-option>
                                    <el-option label="配置" :value="3" key="3"></el-option>
                                    <el-option label="bug" :value="4" key="4"></el-option>
                                    <el-option label="其他" :value="5" key="5"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="所属年月" prop="scptYearMonth">
                                <el-input v-model="form.scptYearMonth" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="标题" prop="scptTitle">
                                <el-input v-model="form.scptTitle" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="内容" prop="scptContent">
                                <el-input v-model="form.scptContent" type="textarea"  :rows="4"  style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="内容描述" prop="scptDes">
                                <el-input v-model="form.scptDes" style="width: 80%;" :rows="4" type="textarea"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="参与人" prop="scptHandlerUser">
                                <el-input v-model="form.scptHandlerUser" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item label="后端状态(1不需要 2需要)" prop="scptStatusBack">
                                <el-radio-group v-model="form.scptStatusBack">
                                    <el-radio :label="1">不需要</el-radio>
                                    <el-radio :label="2">需要</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="前端状态(1不需要 2需要)" prop="scptStatusWeb">
                                <el-radio-group v-model="form.scptStatusWeb">
                                    <el-radio :label="1">不需要</el-radio>
                                    <el-radio :label="2">需要</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="图片" prop="scptImages">
                                <cj-upload ref="xlcjupload" @fileChange="spQrcodeTwoUpfileChange" :filearr="fileListTwo"
                                    :limit="10" style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></cj-upload>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
        <el-dialog title="状态" :visible.sync="dialogStatus" width="70%" top="8vh">
            <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                <div style="width: 100%; height: 100%; padding: 5%">
                    <el-form ref="formDatas" :model="formDatas" label-position="top" label-width="150px"
                        @submit.native.prevent>
                        <el-form-item label="状态" prop="dialogStatusValue">
                            <el-select v-model="dialogStatusValue" filterable placeholder="请选择">
                                <el-option v-for="item in statusAll || []" :label="item.name" :value="item.id"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="closeStatus">取 消</el-button>
                        <el-button type="primary" @click="sureStatus">确 定</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="IsDetail" width="80%" top="8vh">
            <div style="max-height: 500px; overflow-y: scroll">
                <el-descriptions :column="2" border :labelStyle="{
                    color: '#409EFF',
                    textAlign: 'center',
                    width: '14%',
                    fontSize: '12px'
                }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                    <el-descriptions-item label="项目任务名称">{{ DetailArr.spName }}</el-descriptions-item>
                    <el-descriptions-item label="项目任务描述">{{ DetailArr.spRemark }}</el-descriptions-item>
                    <el-descriptions-item label="状态">{{ DetailArr.spStatus }}</el-descriptions-item>
                    <el-descriptions-item label="产品负责人">{{ DetailArr.spPm }}</el-descriptions-item>
                    <el-descriptions-item label="开发人员">{{ DetailArr.spDeveloper }}</el-descriptions-item>
                    <el-descriptions-item label="其他参与人">{{ DetailArr.spParticipant }}</el-descriptions-item>
                    <el-descriptions-item label="访问地址">{{ DetailArr.spAddressAccess }}</el-descriptions-item>
                    <el-descriptions-item label="访问地址https">{{ DetailArr.spAddressAccessHttps }}</el-descriptions-item>
                    <el-descriptions-item label="账号密码">{{ DetailArr.spAccount }}</el-descriptions-item>
                    <el-descriptions-item label="开始时间">{{ DetailArr.spDateStart }}</el-descriptions-item>
                    <el-descriptions-item label="代码存储地址">{{ DetailArr.spSvnGit }}</el-descriptions-item>
                    <el-descriptions-item label="数据库">{{ DetailArr.spSql }}</el-descriptions-item>
                    <el-descriptions-item label="开发端">{{ DetailArr.spPlatform }}</el-descriptions-item>
                    <el-descriptions-item label="相关账号信息">{{ DetailArr.spAccountRelated }}</el-descriptions-item>
                    <el-descriptions-item label="图片描述">{{ DetailArr.spQrcodeOneDes }}</el-descriptions-item>
                    <el-descriptions-item label="图片">
                        <el-image ref="scrImg" id="scrimg" :src="DetailArr.spQrcodeOne" alt="" fit="scale-down"
                            style="width: 100%;height: 50px;" :preview-src-list="[DetailArr.spQrcodeOne]">
                        </el-image>
                    </el-descriptions-item>
                    <el-descriptions-item label="图片描述">{{ DetailArr.spQrcodeTwoDes }}</el-descriptions-item>
                    <el-descriptions-item label="图片">
                        <el-image ref="scrImg" id="scrimg" :src="DetailArr.spQrcodeTwo" alt="" fit="scale-down"
                            style="width: 100%;height: 50px;" :preview-src-list="[DetailArr.spQrcodeTwo]">
                        </el-image>
                    </el-descriptions-item>

                </el-descriptions>

                <p style="width: 100%;text-align: center;margin: 10px 0;">里程碑</p>
                <div v-if="DetailArr.sysCjProjectMilestoneList" style="width: 100%;">
                    <ve-table ref="vetable" v-if="DetailArr.sysCjProjectMilestoneList.length > 0"
                        :columns="columnMilestone" :table-data="DetailArr.sysCjProjectMilestoneList" :max-height="400"
                        :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                        style="width: 100%;" />
                </div>
                <p style="width: 100%;text-align: center;margin: 10px 0;">数据库</p>
                <div v-if="DetailArr.sysCjProjectSqlList" style="width: 100%;">
                    <ve-table ref="vetable" v-if="DetailArr.sysCjProjectSqlList.length > 0" :columns="columnSql"
                        :table-data="DetailArr.sysCjProjectSqlList" :max-height="400" :border-x="true" :border-y="true"
                        :scrollWidth="10" :cell-style-option="cellStyleOption" style="width: 100%;" />
                </div>

            </div>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
let Base64 = require('js-base64').Base64
import { getSysCjProjectList, updateSysCjProjectTaskStatusWeb, getSysCjProjectTaskList, getSysCjProjectDetails, addSysCjProjectTask, updateSysCjProjectTask, updateSysCjProjectTaskStatusBack, deleteSysCjProjectTask, updateSysCjProjectTaskStatus } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getSysCjProjectList_data: [],
            IsDetail: false,
            dialog: false,
            edit: false,
            dialogStatus: false,
            dialogStatusValue: null,
            //状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
            statusAll: [
                { id: 1, name: "不需要" },
                { id: 2, name: "待处理" },
                { id: 3, name: "处理中" },
                { id: 4, name: "已完成" },
            ],
            fileListTwo: [],
            DetailArr: [],
            form: {
                scptType: 1,
                // 默认值为当前年月，格式 YYYYMM（如 202606）
                scptYearMonth: `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`,
                scptTitle: '',
                scptContent: '',
                scptImages: [],
                scptDes: '',
                scptHandlerUser: '',
                createusername:"",
                scptStatusBack: '',
                scptStatusWeb: '',
                spId: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "spName",
                    key: "spName",
                    title: "项目任务名称",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 110,
                },
                {
                    field: "scptStatus",
                    key: "scptStatus",
                    title: "状态",
                    width: 80,
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                            <span>
                                {
                                    row.scptStatus == 1 ? <el-tag type="danger">开启</el-tag> :
                                        <el-tag type="info">关闭</el-tag>
                                }
                                {
                                    row.scptStatus == 2 ? <el-button size="mini" type="text" on-click={() => this.handleStatus1(row, 1)} > 开启 </el-button> : ''
                                }
                                {
                                    row.scptStatus == 1 ? <el-button size="mini" type="text" on-click={() => this.handleStatus1(row, 2)} > 关闭 </el-button> : ''
                                }
                            </span>
                        );
                    },
                },
                
                {
                    field: "scptTitle",
                    key: "scptTitle",
                    title: "标题",
                    align: "left",
                    edit: true,
                    width: 220,
                },
                {
                    field: "scptContent",
                    key: "scptContent",
                    title: "内容",
                    align: "left",
                    edit: true,
                    width: 280,
                },
                {
                    field: "scptDes",
                    key: "scptDes",
                    title: "开发",
                    align: "left",
                    edit: true,
                    width: 280,
                },
                {
                    field: "scptHandlerUser",
                    key: "scptHandlerUser",
                    title: "参与人",
                    align: "center",
                    edit: true,
                    width: 100,
                },

                {
                    field: "scptImages",
                    key: "scptImages",
                    title: "图片",
                    align: "left",
                    width: 180,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.scptImages ? row.scptImages.split(',').map((item => {
                                            const str = this.fileType(item) == 'image' ? <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image> : <el-button
                                                    size="mini"
                                                    type="text"
                                                    style="vertical-align: middle;"
                                                    on-click={() => this.Preview(item)}
                                                >
                                                预览
                                            </el-button>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "scptType",
                    key: "scptType",
                    title: "类型",
                    width: 80,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                            <span>
                                {
                                    row.scptType == 1 ? <el-tag type="success">任务</el-tag> :
                                        (row.scptType == 2 ? <el-tag type="success">需求更改</el-tag> :
                                            (row.scptType == 3 ? <el-tag type="success">配置</el-tag> :
                                                (row.scptType == 4 ? <el-tag type="danger">bug</el-tag> :
                                                    <el-tag type="success">其他</el-tag>)))
                                }

                            </span>
                        );
                    },
                },
                 {
                    field: "scptYearMonth",
                    key: "scptYearMonth",
                    title: "所属年月",
                    align: "left",
                    edit: true,
                    width: 70,
                },
                 {
                    field: "createusername",
                    key: "createusername",
                    title: "创建人",
                    align: "center",
                    edit: true,
                    width: 70,
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, edit: false, align: "center" },
                { field: "updatetime", key: "updatetime", title: "更新时间", width: 160, edit: false, align: "center" },
                {
                    field: "scptStatusBack",
                    key: "scptStatusBack",
                    title: "后端状态",
                    width: 110,
                    align: "center",
                    edit: false,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                            <span>
                                {
                                    row.scptStatusBack == 1 ? <el-tag type="success">不需要</el-tag> :
                                        (row.scptStatusBack == 2 ? <el-tag type="danger">待处理</el-tag> :
                                            (row.scptStatusBack == 3 ? <el-tag type="primary">处理中</el-tag> :
                                                (row.scptStatusBack == 4 ? <el-tag type="success">已完成</el-tag> :
                                                    '')))
                                }
                                {
                                    <el-button size="mini" type="text" on-click={() => this.handleStatus(row, 1)} > 修改 </el-button>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "scptStatusWeb",
                    key: "scptStatusWeb",
                    title: "前端状态",
                    width: 110,
                    align: "center",
                    edit: false,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                            <span>
                                {
                                    row.scptStatusWeb == 1 ? <el-tag type="success">不需要</el-tag> :
                                        (row.scptStatusWeb == 2 ? <el-tag type="danger">待处理</el-tag> :
                                            (row.scptStatusWeb == 3 ? <el-tag type="primary">处理中</el-tag> :
                                                (row.scptStatusWeb == 4 ? <el-tag type="success">已完成</el-tag> :
                                                    '')))
                                }
                                {
                                    <el-button size="mini" type="text" on-click={() => this.handleStatus(row, 2)} > 修改 </el-button>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 90,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            columnMilestone: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "scpmType",
                    key: "scpmType",
                    title: "类型",
                    width: 100,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.scpmType == 1 ? <el-tag type="success">记录</el-tag> : <el-tag type="danger">里程碑</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "scpmName",
                    key: "scpmName",
                    title: "名称",
                    width: 160,
                    align: "center",
                    edit: true,
                },
                {
                    field: "scpmRemark",
                    key: "scpmRemark",
                    title: "描述",
                    align: "center",
                    edit: true,
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
            ],
            columnSql: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "scpsName",
                    key: "scpsName",
                    title: "备份标题",
                    width: 160,
                    align: "center",
                    edit: true,
                },
                {
                    field: "scpsbName",
                    key: "scpsbName",
                    title: "数据库",
                    width: 160,
                    align: "center",
                    edit: true,
                },
                {
                    field: "scpsPath",
                    key: "scpsPath",
                    title: "备份地址",
                    align: "center",
                    edit: false,
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
            ],
            post: null,
            formDatas: {
                scptId: null,
                spName: "",
                spStatus: null,
                dialogStatusValue: null,
                scptStatus: 1,
                // 所属年月范围(Integer, yyyyMM)，例如 202606
                scptYearMonthStart: null,
                scptYearMonthEnd: null,
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.getList();
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getSysCjProjectList().then(res => {
            this.getSysCjProjectList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/sys-cj-project-task/exportSysCjProjectTask',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '项目任务.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        fileType(file) {
            let fileType = '';
            const type = file.split('.').pop();
            if (type === 'jpg' || type === 'png' || type === 'gif') {
                fileType = 'image';
            } else if (type === 'mp4' || type === 'avi') {
                fileType = 'video';
            } else {
                fileType = 'other';
            }
            return fileType;
        },
        removeAfter(file) {
            const url = this.form.scptImages.findIndex(item => item === file)
            this.form.scptImages.splice(url, 1)
        },
        getProjectSql(id) {
            getSysCjProjectDetails({ scptId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            });
        },
        getDetail(id) {
            getSysCjProjectDetails({ scptId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            });
        },
        sureStatus() {
            if (this.theRow.type == 1) {
                updateSysCjProjectTaskStatusBack({ scptId: this.theRow.scptId, scptStatusBack: this.dialogStatusValue }).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "修改成功!",
                        });
                        this.getList();
                    }
                })
                this.dialogStatus = false;
            } else {
                updateSysCjProjectTaskStatusWeb({ scptId: this.theRow.scptId, scptStatusWeb: this.dialogStatusValue }).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "修改成功!",
                        });
                        this.getList();
                    }
                })
                this.dialogStatus = false;
            }

        },
        closeStatus() {
            this.dialogStatus = false;
        },
        handleStatus(row, type, key) {
            console.log(row)
            this.theRow = row;
            this.theRow.type = type
            this.dialogStatusValue = row[key];
            this.dialogStatus = true;
        },
        handleStatus1(row, val) {
            console.log(row)
            this.$confirm("是否确定要修改状态吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = { scptId: row.scptId, scptStatus: val }
                    updateSysCjProjectTaskStatus(s).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "修改成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        spQrcodeOneUpfileChange(file) {
            this.$set(this.form, 'spQrcodeOne', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        spQrcodeTwoUpfileChange(file) {
            if (this.form.scptImages.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.scptImages.indexOf(item) == -1) {
                        this.form.scptImages.push(item)
                    }
                })
            } else {
                this.$set(this.form, 'scptImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = { scptId: row.scptId }
                    console.log(s);
                    deleteSysCjProjectTask({ scptId: row.scptId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.scptImages = data.scptImages ? data.scptImages.split(',') : [];
                if (data.scptImages.length > 0) {
                    this.form.scptImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileListTwo, index, img)
                    })
                }

            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.scptImages = newForm.scptImages ? newForm.scptImages.toString() : []
                        addSysCjProjectTask(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.scptImages = newForm.scptImages ? newForm.scptImages.toString() : []
                        updateSysCjProjectTask(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            // this.$refs['xlcjupload'].clearFiles();
            this.fileListTwo = [];
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.scptId = row.scptId
                    updateSysCjProjectTask(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.scptId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.scptId);
                    }
                });
            }
        },
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.scptId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.scptId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.scptId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getSysCjProjectTaskList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getSysCjProjectTaskList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
            });
        },
        getList() {
            getSysCjProjectTaskList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>